import React from 'react'
import PropTypes from "prop-types";


const SEO = ( {title} ) => {
    return (
        <>
            <meta charSet="utf-8" />
            <title> BytesOasis Ai & Software Solutions in UAE | {title}</title>
            <meta name="robots" content="noindex, follow" />
            <meta name="description" content="We help businesses in the UAE grow with custom software development, modern websites, mobile apps, UI/UX design, and digital marketing. Fast delivery, clean code, and scalable solutions." />
            <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
        </>
    )
}
SEO.propTypes = {
    title: PropTypes.string
};

export default SEO;